import { FC } from 'react';
import { styled } from 'styled-components';
import { type CellProps, ComposableTable } from '@abtasty/design-system';
import { DivWithTooltipOnClamped } from '../DivWithTooltipOnClamped/DivWithTooltipOnClamped';

const MainLine = styled(DivWithTooltipOnClamped)`
  font-weight: 900;
  font-size: 13px;
  line-height: 1.54;
  word-break: break-all;
`;

const SecondaryLine = styled(DivWithTooltipOnClamped)`
  line-height: 1.67;
  font-size: 12px;
  color: ${({ theme }) => theme.dec.color.primary.default.fg.minimal};
`;

const Cell = styled(ComposableTable.Cell)`
  display: block;
  margin: auto 0;

  ${MainLine},${SecondaryLine} {
    width: 100%;
  }
`;

type CellTwoLinesProps = CellProps & {
  text: string;
  secondaryText?: string;
  mainClassName?: string;
};

export const CellTwoLines: FC<CellTwoLinesProps> = ({
  text,
  secondaryText,
  className,
  mainClassName,
  ...cellProps
}) => (
  <Cell {...cellProps} className={className}>
    <MainLine className={mainClassName} key={`main-line-${cellProps.width}`}>
      {text}
    </MainLine>
    {secondaryText && <SecondaryLine>{secondaryText}</SecondaryLine>}
  </Cell>
);
